export { hideFlexPane, mountAndShowFlexPane } from './components/FlexPane';
